import * as React from 'react';
import * as Styled from '../RadioButtons.styled';

interface OwnProps {
  input?: {
    name: string;
    value: string;
  };
  name?: string;
  label: string;
  value?: string | number;
  id: string;
  selected?: boolean;
  checked?: boolean;
  onChange?: (event?: React.ChangeEvent<HTMLInputElement>) => void;
}

const RadioButton: ReactFCWithChildren<OwnProps> = (props) => {
  const { name, label, value, selected, checked, onChange } = props;
  const inputElm = (
    <React.Fragment>
      <Styled.Input
        type="radio"
        name={name}
        value={value}
        id={props.id}
        checked={checked}
        defaultChecked={selected}
        onChange={onChange}
        {...props.input}
      />
      <Styled.Label htmlFor={props.id}>{label}</Styled.Label>
    </React.Fragment>
  );
  return <Styled.Wrapper>{inputElm}</Styled.Wrapper>;
};

export default RadioButton;
